export default __webpack_public_path__ + "static/media/Quoridor.4196ca65.png";